// extracted by mini-css-extract-plugin
export default {"heading-button":"styles_heading-button__jIGdT","collapsing-section":"styles_collapsing-section__5vnW2"};